module.exports = __webpack_public_path__ + "img/ch13_09_夕阳拥抱.c3a55ced.jpg";